export const CONVERSATIONS = 'CONVERSATIONS';
export const CONVERSATIONS_CONTACT_ASSOCIATION_TYPE_ID = 173;
export const HELPDESK = 'HELPDESK';